import { appService } from '../services'
import { IBlvdFbIntegration } from '../types'
import { makeAutoObservable } from 'mobx'
import { SingletonInitService } from '../services/SingletonInitService'

export class IntegrationsStore {
  singletonInitService: SingletonInitService
  fbAuthenticateUrl = ''
  blvdFbIntegrations: IBlvdFbIntegration[] = []
  isConfirmationOpen = false
  integrationToDelete?: IBlvdFbIntegration

  constructor() {
    makeAutoObservable(this)
    this.singletonInitService = new SingletonInitService()
  }

  getFbAuthenticateUrl = () => this.fbAuthenticateUrl
  getBlvdFbIntegrations = () => this.blvdFbIntegrations
  hasBlvdFbIntegrations = () => this.blvdFbIntegrations.length > 0
  getIsConfirmationOpen = () => this.isConfirmationOpen
  getIntegrationToDelete = () => this.integrationToDelete
  getConfirmationText = () => {
    if (this.integrationToDelete) {
      let question = 'Remove Integration for '
      if (this.integrationToDelete.hasFb) {
        question += 'Facebook'
        if (this.integrationToDelete.hasIg) {
          question += ' and '
        }
      }
      if (this.integrationToDelete.hasIg) {
        question += 'Instagram'
      }
      question += '?'

      return question
    }

    return ''
  }

  setFbAuthenticateUrl = (fbAuthenticateUrl: string) => {
    this.fbAuthenticateUrl = fbAuthenticateUrl
  }

  setBlvdFbIntegrations = (blvdFbIntegrations: IBlvdFbIntegration[]) => {
    this.blvdFbIntegrations = blvdFbIntegrations
  }

  setIsConfirmationOpen = (isConfirmationOpen: boolean) => {
    this.isConfirmationOpen = isConfirmationOpen
  }

  setIntegrationToDelete = (integrationToDelete?: IBlvdFbIntegration) => {
    this.integrationToDelete = integrationToDelete
    this.setIsConfirmationOpen(!!integrationToDelete)
  }

  reloadDataFromApi = async () => {
    await this.setFieldsFromApi()
  }

  uninstall = async () => {
    const integration = this.getIntegrationToDelete()
    this.setIntegrationToDelete(undefined)
    if (!integration) {

      return
    }
    await appService.uninstallAuth(integration.fbBlvdBusinessId)
    const integrations = this.getBlvdFbIntegrations().filter((value: IBlvdFbIntegration) => {
      return value !== integration
    })
    this.setBlvdFbIntegrations(integrations)
  }

  disableEnableFb = async () => {
    const integration = this.getIntegrationToDelete()
    this.setIntegrationToDelete(undefined)
    if (!integration) {

      return
    }
    await appService.disableEnableFb(integration.fbBlvdBusinessId)
  }

  initAsync = async () => {
    if (this.singletonInitService.getWasInit()) {
      return
    }
    await this.setFieldsFromApi()
  }

  private setFieldsFromApi = async () => {
    const data = (await appService.getLoginInitData())?.loginInitData
    if (data) {
      this.singletonInitService.setWasInit(true)
      this.setFbAuthenticateUrl(data.fbAuthenticateUrl)
      this.setBlvdFbIntegrations(data.blvdFbIntegrations)
    }
  }
}
